import type { TableView } from "owa-mail-list-store";
import { type SortColumn } from "owa-mail-list-store";
import { isLocalDataBackedMailboxInfo } from "owa-account-source-list/lib/utils/isLocalDataBackedAccount";
import { getMailboxInfo } from "owa-mail-mailboxinfo";
import { isUnifiedInboxMailboxInfo } from "owa-client-types/lib/UnifiedInboxMailboxInfo";
import { isGlobalFeatureEnabled } from "owa-feature-flags";
import getJumpToSortInfo from "./getJumpToSortInfo";

const SUPPORTED_JUMPTO_SORT_COLUMNS = [
    3,
    9,
    8,
    5,
    1,
    14,
    7,
];

export default function shouldShowJumpTo(tableView: TableView | undefined): boolean {
    const sortInfo = getJumpToSortInfo(tableView);
    if (!tableView || !sortInfo) {
        return false;
    }
    
    // Client-sorted tables already hold every result, so Jump To works for any mailbox.
    if (sortInfo.clientSortOrder) {
        return isGlobalFeatureEnabled("sea-searchJumpTo");
    }
    
    const mailboxInfo = getMailboxInfo(tableView);
    return (SUPPORTED_JUMPTO_SORT_COLUMNS.includes(sortInfo.sortColumn) &&
        !isLocalDataBackedMailboxInfo(mailboxInfo) && // Don't show JumpTo for PST files
        !isUnifiedInboxMailboxInfo(mailboxInfo) // Don't show JumpTo for Unified Inbox
    );
}
